module.exports = __webpack_public_path__ + "static/thumbnail-6390b22192e9d77d2c09d88f78afe73f.png";